import axios from "axios"

const baseUrl = "/api/public/appointments"

export default {
  fetchPublicAppointmentOptions() {
    return axios.get(`${baseUrl}/options`).then((response) => response.data)
  },
  fetchPublicAppointmentAvailability(params) {
    return axios.get(`${baseUrl}/availability`, { params }).then((response) => response.data)
  },
  bookPublicAppointment(data) {
    // Guest bookings deliberately carry no stored account token.
    const options = data.mode === "account" ? { headers: { Authorization: localStorage.getItem("token") || "" } } : {}
    return axios.post(`${baseUrl}/book`, data, options).then((response) => response.data)
  },
}
